module.exports = __webpack_public_path__ + "static/img/default.e2c6c81d.jpg";